import { render, staticRenderFns } from "./CategoryManagement.vue?vue&type=template&id=2e9f0a24&scoped=true&"
import script from "./CategoryManagement.vue?vue&type=script&lang=js&"
export * from "./CategoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./CategoryManagement.vue?vue&type=style&index=0&id=2e9f0a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f0a24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VPagination,VRow,VTextField,VToolbar})
